/// <reference path="../../Common/Helpers/GridEditorBase.ts" />

namespace TabAurous.OMS {
    import fld = PriceListDetailsRow.Fields;
    @Serenity.Decorators.registerClass()
    export class FixedRateMasterEditor extends _Ext.GridEditorBase<PriceListDetailsRow> {
        protected getColumnsKey() { return "OMS.FixedRateGrid"; }
        protected getDialogType() { return PriceListDetailsDialog; }
        protected getLocalTextPrefix() { return PriceListDetailsRow.localTextPrefix; }
        protected getInsertPermission() { return PriceListDetailsRow.insertPermission; }
        protected getUpdatePermission() { return PriceListDetailsRow.updatePermission; }
        protected getDeletePermission() { return PriceListDetailsRow.deletePermission; }
        protected useViewMode() { return true; }

        private pendingChanges: Q.Dictionary<any> = {};

        public cols;
        protected form: PriceListDetailsForm;
        amount = 0; markup = 0;
        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: true });
            this.slickGrid.setOptions({ rowHeight: 30 });

        }
        private autoSize;
        public getColumns() {

            var columns = super.getColumns();
            var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
            var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this);


            Q.first(columns, x => x.field === fld.Amount).format = num;


            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            this.view.refresh();
            this.cols = columns;//setting columns for master to filter
            return columns;
        }
        protected getButtons() {
            let buttons = super.getButtons();
            var grid = OMS.FixedRateMasterSelectGrid;
            // grid.apply(this.rowSelection = new Serenity.GridRowSelectionMixin(this));
            //grid.apply(this.getColumns = (Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));

            buttons.push({
                title: "Select Rates",
                cssClass: "add-rate",
                onClick: () => {
                    var pricetype = (this.parentDialog as PriceListDialog).form.PriceType.value;
                    if (pricetype == "") {
                        q.alert("", "Please select Price Type", true, 2999);
                        return;
                    }
                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: true,
                        preSelectedKeys: this.value.map(k => k.AttributeId)
                    });
                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.AttributeId == t.CostId) });
                        this.cols = this.getColumns();//setting columns for master to filter   
                        var rates = [];
                        var columns = super.getColumns().filter(x => x.field != "PurStdRate");
                        selectedItems2.forEach(function (value: FixedRateMasterRow) {

                            var newrate: PriceListDetailsRow = {
                                ProductId: value.ProductId,
                                ProductTypeName: value.ProductTypeName,
                                CategoryName: value.CategoryName,
                                SubCategoryName: value.SubCategoryName,
                                AttributeId: value.AttributeId,
                                Attribute: value.Attribute,
                                FromWt: value.FromWt,
                                ToWt: value.ToWt,

                            }
                            rates.push(newrate);



                        });

                        // alert('Length details' + rates.length);
                        for (let rateitem of rates) {
                            rateitem[this.getIdProperty()] = "`" + this.nextId++;
                            //   alert('ID ' + rateitem.CostId);
                            var x = rateitem;
                            this.view.addItem(rateitem);

                        }
                    }

                    pickerDialog.dialogOpen();
                }
            });

            buttons = buttons.filter(x => x.cssClass != "add-button");
            return buttons;
        }
        // inline delete event handler
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);

            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Delete record?', () => {
                        var id = this.id(item);
                        this.view.deleteItem(id);

                    });
                }
            }
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }

        // Edit event handler
        private inputsChange(e: JQueryEventObject) {
            var rateid = (this.parentDialog as PriceListDialog).form.PriceType.value;
            var ratetype = FixedCodeRow.getLookup().itemById[rateid].FixedName;
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;
            if (field === fld.MarkUp) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            } else if (field === fld.Amount) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }

            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }

            if (field === fld.MarkUp && value > 0) {
                this.markup = value;

                if (ratetype == "PURCHASE RATE") {
                    item.Amount = item.PurStdRate * value;
                    item[field] = value;
                } else if (ratetype == "SALE RATE") {
                    item.Amount = item.SaleStdRate * value;
                    item[field] = value;
                }
                this.view.updateItem(id, item);
                this.view.refresh();

            } else if (field === fld.Amount && value > 0) {

                if (ratetype == "PURCHASE RATE") {
                    item.MarkUp = value / item.PurStdRate;
                    item[field] = value;
                }
                else if (ratetype == "SALE RATE") {
                    item.MarkUp = value / item.SaleStdRate;
                    item[field] = value;
                }
                this.view.updateItem(id, item);
                this.view.refresh();

            }

            if (!pending) {
                this.pendingChanges[id] = pending = {};
            }

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }

        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }

            return item[field];
        }
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }


    }
}